import _objectSpread from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import { mapState } from 'vuex';
export default {
  computed: _objectSpread(_objectSpread({}, mapState('admin/menu', ['siderMenuBadge'])), {}, {
    badgeData: function badgeData() {
      var _this = this;
      var data = null;
      var siderMenuBadge = this.siderMenuBadge.find(function (item) {
        return item.path === _this.menu.path;
      });
      if (siderMenuBadge) data = siderMenuBadge;
      return data;
    }
  })
};